/* eslint-disable no-debugger */
import { Injectable } from '@angular/core';
import { Accession } from '../interfaces/accession';
import { AccessionsListResponse } from '../interfaces/accessionsList';
import { environment } from '@/environments/environment';
import { ToastService } from './script/toast.service';
import axios from 'axios';
import { LoaderService } from '@/app/services/interceptor/loader-service';

@Injectable({
  providedIn: 'root',
})
export class MyAccessionsService {
  private readonly apiUrl = '/api/aurora';

  constructor(
    private toastService: ToastService,
    private loader: LoaderService
  ) {}

  async getAllAccessionsSent(params): Promise<unknown> {
    this.loader.show();
    try {
      const payload = {
        filters: { params },
        list: 'accessions_sent',
      };
      const { data } = await axios.post<AccessionsListResponse>(`${environment.url}${this.apiUrl}/listado`, payload, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      this.toastService.showError(
        'Error al obtener listado adhesiones enviadas',
        error?.message || 'Ha ocurrido un error inesperado'
      );
      throw error;
    } finally {
      this.loader.hide();
    }
  }

  async getAllAccessionsReceived(params): Promise<unknown> {
    this.loader.show();
    try {
      const payload = {
        filters: { params },
        list: 'accessions_received',
      };

      const { data } = await axios.post<AccessionsListResponse>(`${environment.url}${this.apiUrl}/listado`, payload, {
        withCredentials: true,
      });

      return data;
    } catch (error) {
      this.toastService.showError(
        'Error al obtener las adhesiones recibidas',
        error?.response?.data?.message || error?.message || 'Ha ocurrido un error inesperado'
      );
      throw error;
    } finally {
      this.loader.hide();
    }
  }

  async getAccessionById(accesionId, detail): Promise<Accession> {
    try {
      this.loader.show();
      const params = {
        id_adhesion: accesionId,
        detail: detail,
      };
      const response = await axios.post<Accession>(`${environment.url}${this.apiUrl}/detalle`, params, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      this.toastService.showError(
        'Error al obtener el detalle de la adhesión',
        error?.message || 'Ha ocurrido un error inesperado'
      );
      throw error;
    } finally {
      // setTimeout(() => this.loader.hide(), 400);
      this.loader.hide();
    }
  }

  async updateAccesion(params) {
    this.loader.show();
    try {
      const response = await axios.post(`${environment.url}${this.apiUrl}/cambio_estado_adhesion`, params, {
        withCredentials: true,
      });

      const successMessage = this.getAccessionSuccessMessage(params.state);
      this.toastService.showSuccess(successMessage.summary, successMessage.detail);
      return response.data;
    } catch (error) {
      this.toastService.showError(
        'Error al actualizar la adhesión',
        error?.message || 'Ha ocurrido un error inesperado'
      );
      throw error;
    } finally {
      this.loader.hide();
    }
  }
  private getAccessionSuccessMessage(state: string): { summary: string; detail: string } {
    const messages: Record<string, { summary: string; detail: string }> = {
      finalized: {
        summary: 'Adhesión finalizada',
        detail: 'La adhesión se ha finalizado correctamente',
      },
      approved: {
        summary: 'Adhesión aprobada',
        detail: 'La adhesión se ha aprobado correctamente',
      },
      blocked: {
        summary: 'Adhesión bloqueada',
        detail: 'La adhesión se ha bloqueado correctamente',
      },
      rejected: {
        summary: 'Adhesión rechazada',
        detail: 'La adhesión se ha rechazado correctamente',
      },
    };

    return (
      messages[state] ?? {
        summary: 'Adhesión actualizada',
        detail: 'La adhesión se ha actualizado correctamente',
      }
    );
  }
}
